import { Directive, HostBinding, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
  selector: '[appAccordionElementTrigger]'
})
export class AccordionElementTriggerDirective {

  @HostBinding('class') class = 'btn btn-sm btn-link font-weight-bold';

  @Output() buttonClick = new EventEmitter<void>();

  @HostListener('click')
  onClick() {
    this.buttonClick.emit();
  }

  constructor() { }

}
